import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Saber exactamente qué darle de comer a tu perro', 'Preparar comidas naturales fáciles en casa', 'Mejorar su salud, digestión y energía', 'Evitar errores y sentirte segura con lo que le das', 'Empezar hoy mismo con un paso a paso claro'];
export function TransformationSection() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-251">
      <div className="max-w-3xl mx-auto" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-253">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-4 leading-tight" data-id="element-254">
            Por eso creamos <br data-id="element-255" />
            <span className="text-primary" data-id="element-256">Nutrición Canina Fácil</span>
          </h2>

          <p className="text-lg md:text-xl text-gray-600 mb-8 font-medium max-w-xl mx-auto" data-id="element-257">
            Un ebook práctico y paso a paso pensado para que puedas alimentar a
            tu perro de forma natural, sin errores ni confusión.
          </p>

          <div className="space-y-5 max-w-md mx-auto text-left" data-id="element-258">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center" data-id="element-259">
                <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mr-4" data-id="element-260" />
                <span className="text-lg text-gray-800" data-id="element-261">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}